/**
 * All the best — flower elastic entrance on scroll + lid video play (GSAP + ScrollTrigger).
 * Depends on assets/cu-window.js (layout/theme.liquid).
 */
(function () {
  function loadScrollTrigger() {
    if (window.CU && typeof window.CU.loadScrollTrigger === 'function') {
      return window.CU.loadScrollTrigger();
    }
    return Promise.reject(new Error('CU All the best: cu-window.js not loaded.'));
  }

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function resetVideoPlayback(video) {
    if (!video) {
      return;
    }
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
  }

  function playVideoWhenReady(video) {
    if (!video) {
      return;
    }
    function tryPlay() {
      try {
        video.currentTime = 0;
      } catch (e) {}
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {});
      }
    }
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener(
        'canplay',
        function () {
          tryPlay();
        },
        { once: true }
      );
    }
  }

  /**
   * @param {HTMLElement} root — [data-cu-allthebest-root]
   */
  function initCuAllTheBest(root) {
    if (!root || root.dataset.cuAllthebestReady === 'true') {
      return;
    }

    var enable =
      root.getAttribute('data-enable-animation') !== 'false';
    if (!enable) {
      root.dataset.cuAllthebestReady = 'true';
      return;
    }

    if (prefersReducedMotion()) {
      root.dataset.cuAllthebestReady = 'true';
      return;
    }

    var flowers = root.querySelectorAll('.allthebest_flower');
    var triggerEl = root.querySelector('.allthebest_flower-container');
    var video =
      root.querySelector('video') ||
      root.querySelector('[data-allthebest-video]');

    if (!triggerEl || !flowers.length) {
      root.dataset.cuAllthebestReady = 'true';
      return;
    }

    var scrollStart =
      root.getAttribute('data-scroll-start') || 'top 70%';
    var duration = parseFloat(
      root.getAttribute('data-flower-duration') || '1.5'
    );
    var stagger = parseFloat(
      root.getAttribute('data-flower-stagger') || '0.1'
    );
    var delay = parseFloat(
      root.getAttribute('data-flower-delay') || '1'
    );

    function setupGsap(gsap) {
      if (!root.isConnected) {
        return;
      }

      if (root._cuAllTheBestCtx) {
        root._cuAllTheBestCtx.revert();
        root._cuAllTheBestCtx = null;
      }

      if (isNaN(duration) || duration <= 0) {
        duration = 1.5;
      }
      if (isNaN(stagger) || stagger < 0) {
        stagger = 0.1;
      }
      if (isNaN(delay) || delay < 0) {
        delay = 1;
      }

      gsap.config({ nullTargetWarn: false });

      var ctxScope = root.closest('.section_allthebest') || root;
      var flowersAnimated = false;

      var ctx = gsap.context(function () {
        gsap.set(flowers, { scale: 0, transformOrigin: '50% 50%' });

        function onSectionInView() {
          playVideoWhenReady(video);
          if (!flowersAnimated) {
            flowersAnimated = true;
            gsap.to(flowers, {
              scale: 1,
              duration: duration,
              ease: 'elastic.out(0.4, 0.3)',
              stagger: stagger,
              delay: delay,
            });
          }
        }

        function onSectionOutOfView() {
          resetVideoPlayback(video);
        }

        ScrollTrigger.create({
          trigger: triggerEl,
          start: scrollStart,
          onEnter: onSectionInView,
          onEnterBack: onSectionInView,
          onLeave: onSectionOutOfView,
          onLeaveBack: onSectionOutOfView,
        });
      }, ctxScope);

      root._cuAllTheBestCtx = ctx;
      root.dataset.cuAllthebestReady = 'true';
    }

    var setupStarted = false;

    function run() {
      if (setupStarted) {
        return;
      }
      setupStarted = true;
      loadScrollTrigger()
        .then(function (gsap) {
          setupGsap(gsap);
        })
        .catch(function () {
          for (var j = 0; j < flowers.length; j++) {
            flowers[j].style.transform = '';
          }
          root.dataset.cuAllthebestReady = 'true';
        });
    }

    function onVideoReady() {
      run();
    }

    if (!video) {
      onVideoReady();
      return;
    }

    function tryInitFromVideo() {
      if (video.readyState >= 3) {
        onVideoReady();
        return true;
      }
      return false;
    }

    if (tryInitFromVideo()) {
      return;
    }

    video.addEventListener('loadeddata', onVideoReady, { once: true });

    window.addEventListener(
      'load',
      function () {
        if (root.dataset.cuAllthebestReady === 'true') {
          return;
        }
        if (tryInitFromVideo()) {
          return;
        }
        setTimeout(function () {
          if (root.dataset.cuAllthebestReady === 'true') {
            return;
          }
          onVideoReady();
        }, 1500);
      },
      { once: true }
    );
  }

  function destroyCuAllTheBest(root) {
    if (!root) {
      return;
    }
    if (root._cuAllTheBestCtx) {
      root._cuAllTheBestCtx.revert();
      root._cuAllTheBestCtx = null;
    }
    delete root.dataset.cuAllthebestReady;
  }

  function scanAndInit(container) {
    var scope = container || document;
    var nodes = scope.querySelectorAll('[data-cu-allthebest-root]');
    for (var i = 0; i < nodes.length; i++) {
      initCuAllTheBest(nodes[i]);
    }
  }

  function registerGlobalListenersOnce() {
    if (window.__cuAllTheBestListeners) {
      return;
    }
    window.__cuAllTheBestListeners = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        scanAndInit();
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      scanAndInit(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll('[data-cu-allthebest-root]');
      for (var i = 0; i < roots.length; i++) {
        destroyCuAllTheBest(roots[i]);
      }
    });
  }

  registerGlobalListenersOnce();
  scanAndInit();
})();
